import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import rfq from "../../images/Icons/rfq.png";
import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import config from "../../config";
import { useDispatch, useSelector } from "react-redux";
import { fetchAddress as fetchSavedAddress } from "../../redux/slice/address";
import useLogout from "../Auth/useLogout";
import { Link } from "react-router-dom";

export default function CreateRfq() {
  const location = useLocation();
  const navigate = useNavigate();
  const logout = useLogout();
  const productData = location.state;

  useEffect(() => {
    if (!productData) {
      navigate("/");
    }
  }, [productData, navigate]);

  const [loading, setLoading] = useState(false);
  const [billing, setBilling] = useState({
    index: null,
    data: null,
  });
  const handleBilling = (data, index) => {
    if (data !== null && index !== null) {
      setBilling({
        data: data,
        index: index,
      });
    }
  };
  const [consignee, setConsignee] = useState({
    index: null,
    data: null,
  });
  const handleConsignee = (data, index) => {
    if (data !== null && index !== null) {
      setConsignee({
        data: data,
        index: index,
      });
    }
  };
  const [isChecked, setIsChecked] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSame = () => {
    setIsChecked(!isChecked);
    if (isChecked) {
      setConsignee({
        data: billing.data,
        index: billing.index,
      });
    }

    if (!isChecked) {
      setConsignee({
        data: null,
        index: null,
      });
    }
  };
  const [formData, setFormData] = useState({
    purpose: "",
    message: "",
  });
  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateSubmit = () => {
    const newError = {};

    if (!billing.data) {
      newError.billingError = "Please select billing address";
      fireToast(newError.billingError);
    }
    if (!consignee.data) {
      newError.consigneeError = "Please select consignee detail";
      fireToast(newError.consigneeError);
    }

    return Object.keys(newError).length === 0;
  };
  const fireToast = (data) => {
    toast.error(data, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateSubmit()) {
      setLoading(true);
      const variation = productData.finalVariations;
      const product = productData.product;
      const quality = productData.selectedQuality;
      const packagingCharge = productData.selectedPackagingCharge;
      try {
        const response = await axios.post(
          `${config.apiUrl}/product-enquiry`,
          {
            commodity_product_id: product.commodity_product_id,
            brand_id: product.brand.id,
            origin_city: product.address,
            quality: quality,
            packaging_charge: packagingCharge,
            variation: variation,
            billing_address: billing.data,
            consignee_detail: consignee.data,
            purpose: formData.purpose,
            description: formData.message,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );

        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setTimeout(() => {
          resetData();
          navigate("/quotation-list/sent", { replace: true });
        }, 1500);
      } catch (error) {
        setIsModalOpen(true);

        // toast.error(error.response.data.message, {
        //   position: "top-right",
        //   autoClose: 2000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        // });
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    }
  };
  const resetData = () => {
    setBilling({
      data: null,
      index: null,
    });
    setConsignee({
      data: null,
      index: null,
    });
    setFormData({
      purpose: "",
      message: "",
    });
  };

  const dispatch = useDispatch();
  const { addressData, isError } = useSelector((state) => state.address);
  useEffect(() => {
    if (!isError) {
      dispatch(fetchSavedAddress(logout));
    }
  }, [dispatch, isError, logout]);

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <div className="create-rfq">
                <div className="row-hd-txt">
                  <div className="row-hd-txt-left">
                    <img src={rfq} alt="icon" />
                    <h5>Request For Quotes</h5>
                  </div>
                </div>
                <form onSubmit={handleSubmit} className="rfq-form">
                  <div className="row mb-1 pb-1 gy-3 mt-2 bg-light align-items-center rounded f-500">
                    <div className="col-lg-12">
                      Please fill the form to send enquiry <span>*</span>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-lg-12">
                      {productData && (
                        <>
                          <table className="table chart-table table-bordered m-0">
                            <tbody>
                              <tr>
                                <td>
                                  <span className="tag">Product Name:</span>
                                </td>
                                <td>{productData.product.name}</td>
                              </tr>
                              <tr>
                                <td>
                                  <span className="tag">Product Brand:</span>
                                </td>
                                <td>{productData.product.brand.name}</td>
                              </tr>
                              <tr>
                                <td>
                                  <span className="tag">Location:</span>
                                </td>
                                <td>{productData.product.address}</td>
                              </tr>
                              <tr>
                                <td>
                                  <span className="tag">Selected Sizes:</span>
                                </td>
                                <td>
                                  {productData.finalVariations.map(
                                    (stats, index) => (
                                      <span className="mr-3" key={index}>
                                        {stats.value[0].value}
                                        <small>
                                          {stats.value[0].unit.short_name}
                                        </small>
                                        {" - "}
                                        {stats.quantity}
                                        <small>Qty</small>
                                        {", "}
                                      </span>
                                    )
                                  )}
                                </td>
                              </tr>
                              {productData.selectedQuality && (
                                <tr>
                                  <td>
                                    <span className="tag">
                                      Selected Quality:
                                    </span>
                                  </td>
                                  <td>
                                    <span className="mr-3">
                                      {productData.selectedQuality.name}
                                    </span>
                                  </td>
                                </tr>
                              )}
                              {productData.selectedPackagingCharge && (
                                <tr>
                                  <td>
                                    <span className="tag">
                                      Selected Packaging:
                                    </span>
                                  </td>
                                  <td>
                                    <span className="mr-3">
                                      {productData.selectedPackagingCharge.name}
                                    </span>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="row mb-2 pb-1 gy-3 bg-light align-items-center rounded">
                    <div className="col-6">
                      <p className="mb-0 f-500">
                        Billing Address(Bill To)
                        <span>*</span>
                      </p>
                    </div>
                    <div className="col-6 text-end">
                      <Link
                        to="/address"
                        type="button"
                        className="custom-btn text-white"
                        title="Add Address"
                      >
                        Add New
                      </Link>
                    </div>
                  </div>
                  <div className="row mb-3 gx-4">
                    {addressData.length > 0 ? (
                      addressData.map((data, index) => (
                        <div className="col-lg-6 col-md-6 px-2" key={index}>
                          <div className="address-area p-5">
                            <table className="table chart-table table-bordered m-0">
                              <tbody>
                                <tr>
                                  <td>Company Name:</td>
                                  <td>{data.company_name}</td>
                                </tr>
                                <tr>
                                  <td>Phone Number:</td>
                                  <td>{data.phone}</td>
                                </tr>
                                <tr>
                                  <td>Gst Number:</td>
                                  <td>{data.gst}</td>
                                </tr>
                                <tr>
                                  <td>Address Line1:</td>
                                  <td>{data.address_line_one}</td>
                                </tr>
                                <tr>
                                  <td>Address Line2:</td>
                                  <td>{data.address_line_two}</td>
                                </tr>
                                <tr>
                                  <td>City:</td>
                                  <td>{data.city}</td>
                                </tr>
                                <tr>
                                  <td>State:</td>
                                  <td>{data.state}</td>
                                </tr>
                                <tr>
                                  <td>Pincode:</td>
                                  <td>{data.pincode}</td>
                                </tr>
                              </tbody>
                            </table>
                            <div className="address-btn">
                              <div className="form-check">
                                <input
                                  className="form-check-input custom_check"
                                  type="checkbox"
                                  checked={billing.index === index}
                                  onChange={() => handleBilling(data, index)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-lg-12 text-center">
                        <p className="m-0 text-danger">
                          Sorry, you don't have any saved address.
                        </p>
                      </div>
                    )}
                  </div>

                  <div className="row mb-2 pb-1 gy-3 bg-light align-items-center rounded">
                    <div className="col-6">
                      <p className="mb-0 f-500">
                        Consignee Details(Ship To)
                        <span>*</span>
                      </p>
                    </div>
                    {addressData.length > 0 && (
                      <div className="col-6">
                        <div className="form-check d-flex float-end">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            onChange={handleSame}
                            id="sameasabove"
                          />
                          <label
                            className="form-check-label ms-2 fw-bold"
                            htmlFor="sameasabove"
                          >
                            Same as billing address
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="row mb-3 gx-4">
                    {addressData.length > 0 ? (
                      addressData.map((data, index) => (
                        <div className="col-lg-6 col-md-6 px-2" key={index}>
                          <div className="address-area p-5">
                            <table className="table chart-table table-bordered m-0">
                              <tbody>
                                <tr>
                                  <td>Company Name:</td>
                                  <td>{data.company_name}</td>
                                </tr>
                                <tr>
                                  <td>Phone Number:</td>
                                  <td>{data.phone}</td>
                                </tr>
                                <tr>
                                  <td>Gst Number:</td>
                                  <td>{data.gst}</td>
                                </tr>
                                <tr>
                                  <td>Address Line1:</td>
                                  <td>{data.address_line_one}</td>
                                </tr>
                                <tr>
                                  <td>Address Line2:</td>
                                  <td>{data.address_line_two}</td>
                                </tr>
                                <tr>
                                  <td>City:</td>
                                  <td>{data.city}</td>
                                </tr>
                                <tr>
                                  <td>State:</td>
                                  <td>{data.state}</td>
                                </tr>
                                <tr>
                                  <td>Pincode:</td>
                                  <td>{data.pincode}</td>
                                </tr>
                              </tbody>
                            </table>
                            <div className="address-btn">
                              <div className="form-check">
                                <input
                                  className="form-check-input custom_check"
                                  type="checkbox"
                                  checked={consignee.index === index}
                                  onChange={() => handleConsignee(data, index)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-lg-12 text-center">
                        <p className="m-0 text-danger">
                          Sorry, you don't have any saved address.
                        </p>
                      </div>
                    )}
                  </div>

                  <div className="row mb-2 pb-1 gy-3 bg-light align-items-center rounded f-500">
                    <div className="col-lg-12">
                      Other Details
                      <span>*</span>
                    </div>
                  </div>
                  <div className="row gx-4">
                    <div className="col-lg-4 px-2">
                      <label>Buying Purpose*</label>
                      <div className="select-wrapper">
                        <select
                          name="purpose"
                          value={formData.purpose}
                          onChange={handleFormChange}
                          className="form-control select-with-arrow"
                        >
                          <option value="" disabled>
                            Select Buying Purpose
                          </option>
                          <option value="Trading">Trading</option>
                          <option value="Retail">Retail</option>
                          <option value="Wholesale">Wholesale</option>
                          <option value="Personal Use">Personal Use</option>
                          <option value="For Government/Private Projects">
                            For Government/Private Projects
                          </option>
                          <option value="Other">Other</option>
                        </select>
                        <span className="select-arrow" aria-hidden="true"></span>
                      </div>
                    </div>
                    <div className="col-lg-8 px-2">
                      <label htmlFor="message">Your Message*</label>
                      <input
                        type="text"
                        className="form-control"
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleFormChange}
                        placeholder="Write Your Own Message"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-lg-12 text-end">
                      <button
                        type="submit"
                        className="submit_btn"
                        disabled={loading}
                        title="Submit"
                      >
                        <i className="bi bi-floppy"></i>
                        {loading ? "Submitting" : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {isModalOpen && (
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Warning</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <h5>Your balance is not sufficient to place an enquiry.</h5>
                  <Link
                    to="/enquiry"
                    type="button"
                    className="custom-btn text-white"
                    title="Go for General Enquiry"
                  >
                    Go for General Enquiry
                  </Link>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setIsModalOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
